import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/multiplex-respiratory-antigen-test-accelerating-ivdr-market-access")({
  head: () => buildRouteHead("/es/casos-de-exito/multiplex-respiratory-antigen-test-accelerating-ivdr-market-access", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/test-multiplex-de-antigenos-respiratorios-acelerando-el-acceso-al-mercado-segun-el-ivdr", replace: true });
  },
});
